import React, { Component } from "react";

import LocalizedStrings from "react-localization";
import en from "../../localization/localization-en.json";
import VideoPlayer from "../video_player";

let strings = new LocalizedStrings({ en });

class CreateRecommendation extends Component {
  state = {};
  render() {
    return (
      <div className="create_recommendation row max_width_500">
        <div className="create_recommendation_input">
          <textarea
            type="text"
            className=""
            value={this.props.recommendation}
            placeholder={strings.create_reco}
            onChange={this.handleChangeRecommendation}
          />
        </div>

        <div className="create_recommendation_ratio">
          <div className="max_width_300">
            <label
              htmlFor="image-upload"
              className="yaystack_color create_recommendation_image cursor_btn"
            >
              {this.renderImage()}
              {this.renderUrl()}
            </label>
            <input
              type="file"
              className="input-file "
              accept="video/mp4,video/quicktime,image/*"
              id="image-upload"
              name="image-upload"
              onChange={this.handleChangeImage}
            />
          </div>
        </div>
      </div>
    );
  }

  renderImage() {
    if (this.props.image == null) {
      if (this.props.video == null) {
        return <ion-icon class="ion-icon" name="ios-add" />;
      }
      const videoJsOptions = {
        autoplay: true,
        controls: true,
        muted: true,
        loop: true,
        playsInline: true,
        sources: [
          {
            src: this.props.video,
            type: "video/mp4"
          }
        ]
      };
      return <VideoPlayer {...videoJsOptions} createPage={true} />;
    }

    return <img src={this.props.image} alt="upload" />;
  }

  renderUrl() {
    if (this.props.image != null && this.props.imageFile == null) {
      return (
        <div className="div_url">
          <label className="url_title">{this.props.url_title}</label>
          <label className="url_description">
            {this.props.url_description}
          </label>
        </div>
      );
    }
  }

  handleChangeRecommendation = event => {
    this.props.handleChangeRecommendation(event.target.value);
  };

  handleChangeImage = event => {
    this.props.handleChangeImage(event);
  };
}

export default CreateRecommendation;



// WEBPACK FOOTER //
// ./src/components/create_recommendation/create_recommendation.jsx